import React, { useRef, useEffect, useState } from "react";
import style from "./ModulePage.module.css";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import AreaChart from "../../assests/areaChart.png";
import Chart from "chart.js/auto";
import { Bar } from "react-chartjs-2";
import LeaderImage from "../../assests/wgferg2 5.png";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import { baseurl } from "../Url";
import { useNavigate } from "react-router-dom";
import Loader from "../Loder/Loader";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import Profile from "../../assests/Profile-PNG-File.png";
import skillIcon from "../../assests/skillIcon.png";
import learnIcon from "../../assests/learnIcon.png";
import expand from "../../assests/expand.svg";
import collapse from "../../assests/collapse.svg";
import TabLayout from "../PracticewithTs/TabLayout/TabLayout";
import TroubleSpots from "../PracticewithTs/TroubleSpots/TroubleSpots";
import Strength from "../Strength/Strength.jsx";
import Trouble from "../Trouble/Trouble.jsx";
import { useLocation } from "react-router-dom";
import Study from "../../assests/study.png";
import TargetIcon from "../../assests/Group 633.png"
import Mastery_needFocus from "../../assests/Mastery_needFocus.png";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

const getExpandedModuleIndices = (topics) =>
  (topics || [])
    .map((topic, index) => (topic.isExpand ? index : -1))
    .filter((index) => index >= 0);

const getExpandedIndicesForNav = (topics, moduleIndex) => {
  const indices = new Set(getExpandedModuleIndices(topics));
  if (typeof moduleIndex === "number" && moduleIndex >= 0) {
    indices.add(moduleIndex);
  }
  return [...indices];
};

const mergeExpandedIndices = (indices, scrollToModuleIndex) => {
  const set = new Set(indices || []);
  if (typeof scrollToModuleIndex === "number" && scrollToModuleIndex >= 0) {
    set.add(scrollToModuleIndex);
  }
  return set.size ? [...set] : null;
};

const applyExpandedModuleIndices = (data, indices) => {
  if (!data?.Topics?.length || !indices?.length) return data;
  const indexSet = new Set(indices);
  return {
    ...data,
    Topics: data.Topics.map((topic, i) => ({
      ...topic,
      isExpand: indexSet.has(i),
    })),
  };
};

const ModulePage = () => {
  const navigate = useNavigate();

  const {
    userDetails,
    status: userStatus,
    error: userError,
  } = useSelector((state) => state.user);

  const [learningData, setLearningData] = useState({});
  const [loading, setLoading] = useState(true);
  const [selectedTab, setSelectedTab] = useState(0);
  const [learningPaceData, setLearningPaceData] = useState({});
  const [learningLevelData, setLearningLevelData] = useState({});
  const [learningLevelModID, setLearningLevelModID] = useState("");
  const [learningPaceModID, setLearningPaceModID] = useState("");
  const [dateForLP, setDateForLP] = useState("weekly");
  const [enabledTopicForTrialUSer, setEnabledTopicForTrialUSer] = useState(1);
  const [leaderBoardData, setLeaderBoardData] = useState([]);
  const [skillsTab, setSkillsTab] = useState("all-skills");
  const [skillsPanelsActive, setSkillsPanelsActive] = useState(false);
  const [view, setView] = useState("default");
  const [searchTerm, setSearchTerm] = useState(""); // <- added to prevent runtime error

  const handleLPDate = (date) => {
    setDateForLP(date);
  };
  const tabSectionRef = useRef(null);
  const moduleRefs = useRef({});
  const moduleSectionRef = useRef(null);
  const persistedExpandedIndicesRef = useRef(null);
  const location = useLocation();

  const syncExpandedIndicesRef = (topics) => {
    const indices = getExpandedModuleIndices(topics);
    persistedExpandedIndicesRef.current = indices.length ? indices : null;
  };

  useEffect(() => {
    if (
      location.state?.openTroubleSpotTab ||
      location.state?.initialSkillsTab === "trouble-spots"
    ) {
      setSkillsTab("trouble-spots");
      setSkillsPanelsActive(true);
    } else if (location.state?.initialSkillsTab === "all-skills") {
      setSkillsTab("all-skills");
    } else if (location.state?.initialSkillsTab === "Strength") {
      setSkillsTab("Strength");
      setSkillsPanelsActive(true);
    }
  }, [location.state?.openTroubleSpotTab, location.state?.initialSkillsTab]);

  useEffect(() => {
    if (skillsTab === "trouble-spots" || skillsTab === "Strength") {
      setSkillsPanelsActive(true);
    }
  }, [skillsTab]);

  useEffect(() => {
    const shouldScrollToTabs =
      (location.state?.openTroubleSpotTab ||
        location.state?.initialSkillsTab === "trouble-spots" ||
        location.state?.scrollToTabSection) &&
      !loading;
    if (!shouldScrollToTabs) return;
    const scrollToTabSection = () => {
      if (tabSectionRef.current) {
        tabSectionRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    };
    const t = setTimeout(scrollToTabSection, 150);
    return () => clearTimeout(t);
  }, [
    location.state?.openTroubleSpotTab,
    location.state?.initialSkillsTab,
    location.state?.scrollToTabSection,
    loading,
  ]);

  useEffect(() => {
    if (!location.state?.scrollToModuleSection || loading) return;

    setSkillsTab("all-skills");

    const scrollToModuleSection = () => {
      if (moduleSectionRef.current) {
        moduleSectionRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    };

    const t = setTimeout(scrollToModuleSection, 200);
    return () => clearTimeout(t);
  }, [location.state?.scrollToModuleSection, loading]);

  const toggleExpandAll = () => {
    setLearningData((prev) => {
      if (!prev?.Topics) return prev;
      const allExpanded = prev.Topics.every((topic) => topic.isExpand);
      const next = {
        ...prev,
        Topics: prev.Topics.map((topic) => ({
          ...topic,
          isExpand: !allExpanded,
        })),
      };
      syncExpandedIndicesRef(next.Topics);
      return next;
    });
  };
  const toggleExpand = (index) => {
    setLearningData((prev) => {
      const updatedTopics = prev.Topics.map((topic, i) => {
        if (i === index) {
          return { ...topic, isExpand: !topic.isExpand };
        }
        return topic;
      });
      const next = { ...prev, Topics: updatedTopics };
      syncExpandedIndicesRef(next.Topics);
      return next;
    });
  };
  const loggedInUserId = localStorage.getItem("USERID");

  const handlePracticeAgain = () => {
    setSkillsTab("all-skills");
    setView("default");
    setSearchTerm("");
  };
  const fectchAiId = async (topicID) => {
    const token = localStorage.getItem("access-token");
    const userId = localStorage.getItem("USERID");

    if (!token) return null;

    try {
      const response = await fetch(`${baseurl}/userlessons_ai/get`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          user_id: userId,
          topic_id: topicID,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        return data?.data?.[0]?.ai_id || null;
      }
    } catch (error) {
      console.error("Error fetching AI ID:", error);
    }

    return null;
  };

  const learningPaceLabels = learningPaceData?.data?.map((item) =>
    dateForLP === "yearly"
      ? dayjs(item.period).format("MMM")
      : dayjs(item.period).format("DD"),
  );

  const firstLLDate =
    learningPaceData?.data?.length > 0
      ? learningPaceData?.data[0]["period"]
      : "";
  const lLMonthName = firstLLDate ? dayjs(firstLLDate).format("MMM") : "";

  const topicCounts = learningPaceData?.data?.map((item) => item.topic_count);

  const learningPaceChartData = {
    labels: learningPaceLabels,
    datasets: [
      {
        label:
          dateForLP === "yearly" ? "Monthly Topic Count" : "Daily Topic Count",
        data: topicCounts,
        backgroundColor: "#FF8800",
        barThickness: 20,
        borderRadius: 10,
      },
    ],
  };

  const learningPaceOptions = {
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `No of Topics ${context.raw}`;
          },
        },
      },
      zoom: {
        zoom: {
          wheel: { enabled: false },
          pinch: { enabled: false },
          mode: "xy",
        },
        pan: { enabled: false },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: dateForLP === "yearly" ? "Month" : `Day (${lLMonthName})`,
        },
        grid: { display: false },
        beginAtZero: false,
        ticks: { stepSize: 1 },
      },
      y: {
        title: { display: true, text: "Total no.of topics" },
        beginAtZero: true,
        max: learningPaceData.module_topics_count,
        ticks: {
          stepSize: 1,
          callback: function (value) {
            return value;
          },
        },
        grid: { drawBorder: false, drawTicks: false },
      },
    },
  };

  const learningLevelGraphData = {
    labels: [...Array(learningLevelData?.module_topics_count).keys()],
    datasets: [
      {
        label: "Baseline Score",
        data: learningLevelData?.data?.map((topicArray) => {
          const baselineData = topicArray.find(
            (topic) => topic.score_level === "baseline",
          );
          return baselineData ? parseFloat(baselineData.score) : null;
        }),
        backgroundColor: "#595BDB",
        barThickness: 20,
        borderRadius: 10,
      },
      {
        label: "Current Score",
        data: learningLevelData?.data?.map((topicArray) => {
          const currentData = topicArray.find(
            (topic) => topic.score_level === "current",
          );
          return currentData ? parseFloat(currentData.score) : null;
        }),
        backgroundColor: "#FFBE00",
        barThickness: 20,
        borderRadius: 10,
      },
    ],
  };

  const learningLevelOptions = {
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          title: function (context) {
            const topicIndex = context[0].dataIndex + 1;
            return `Topic ${topicIndex}`;
          },
          label: function (context) {
            return `${context.dataset.label}: ${context.raw}%`;
          },
        },
      },
      zoom: {
        zoom: {
          wheel: { enabled: false },
          pinch: { enabled: false },
          mode: "xy",
        },
        pan: { enabled: false },
      },
    },
    scales: {
      x: {
        title: { display: true, text: "Topics" },
        grid: { display: false },
        ticks: {
          stepSize: 1,
          callback: function (value) {
            return value + 1;
          },
        },
      },
      y: {
        title: { display: true, text: "Score (%)" },
        beginAtZero: true,
        max: 100,
        ticks: {
          stepSize: 20,
          callback: function (value) {
            return value + "%";
          },
        },
        grid: { drawBorder: false, drawTicks: false },
      },
    },
  };

  async function learningList() {
    await fetch(`${baseurl}/userlearning/details/v2`, {
      method: "POST",
      body: JSON.stringify({ user_id: userDetails && userDetails._id?.$oid }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDetails && userDetails.auth_token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === true) {
          const initialModuleId = data.data[0]?.Topics[0].module_id;
          setLearningPaceModID(initialModuleId);
          setLearningLevelModID(initialModuleId);
          const modifiedData = data.data.map((item) => {
            const topicsWithNoModuleName = [];
            const topicsWithModuleName = [];

            item.Topics.forEach((topic) => {
              if (!topic.module_name) {
                topic.module_name = "General topics";
                topicsWithNoModuleName.push(topic);
              } else {
                topicsWithModuleName.push(topic);
              }
            });

            item.Topics = [
              ...topicsWithModuleName,
              ...topicsWithNoModuleName,
            ].map((topic) => {
              topic.isExpand = false;
              return topic;
            });

            return item;
          });

          if (location.state?.returnFromLearnOrSkill) {
            let targetIdx = location.state?.scrollToModuleIndex;
            if (
              (typeof targetIdx !== "number" || targetIdx < 0) &&
              (location.state?.targetModuleId || location.state?.targetModuleName)
            ) {
              const foundIdx = modifiedData[0]?.Topics?.findIndex(
                (t) =>
                  (location.state?.targetModuleId &&
                    (t.module_id === location.state.targetModuleId ||
                      t.id === location.state.targetModuleId ||
                      t._id === location.state.targetModuleId)) ||
                  (location.state?.targetModuleName &&
                    t.module_name?.trim().toLowerCase() ===
                      location.state.targetModuleName?.trim().toLowerCase())
              );
              if (foundIdx !== undefined && foundIdx >= 0) {
                targetIdx = foundIdx;
              }
            }

            const returnIndices = mergeExpandedIndices(
              location.state?.expandedModuleIndices,
              targetIdx,
            );
            if (returnIndices?.length) {
              persistedExpandedIndicesRef.current = returnIndices;
            }
          }

          const indicesToApply = persistedExpandedIndicesRef.current;
          const baseData = modifiedData[0];
          const nextData = indicesToApply?.length
            ? applyExpandedModuleIndices(baseData, indicesToApply)
            : baseData;
          setLearningData(nextData);
          if (indicesToApply?.length) {
            syncExpandedIndicesRef(nextData.Topics);
          }
          setLoading(false);
        } else {
          // setTimeout(() => setLoading(false), 1500);
          setLearningData({});
          setLoading(false);
        }
      });
  }

  async function learningPace(modID, date) {
    await fetch(`${baseurl}/performance/topic-count`, {
      method: "POST",
      body: JSON.stringify({
        user_id: userDetails && userDetails._id?.$oid,
        module_id: modID,
        filter: date,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDetails && userDetails.auth_token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setLearningPaceData(data);
      });
  }

  async function learningLevel(modID) {
    await fetch(`${baseurl}/performance/learning-level`, {
      method: "POST",
      body: JSON.stringify({
        user_id: userDetails && userDetails._id?.$oid,
        module_id: modID,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDetails && userDetails.auth_token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === true) setLearningLevelData(data);
        else setLearningLevelData({});
      });
  }

  async function getLeaderBoard() {
    await fetch(`${baseurl}/leader_board`, {
      method: "POST",
      body: JSON.stringify({
        org_id: userDetails && userDetails.org_id,
        user_id: loggedInUserId,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDetails && userDetails.auth_token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === true) setLeaderBoardData(data.data);
        else setLeaderBoardData([]);
      });
  }

  useEffect(() => {
    if (userDetails) {
      learningList();
      getLeaderBoard();
    }
  }, [userDetails]);
  useEffect(() => {
    if (location.state?.tab) {
      setSkillsTab(location.state.tab);
    } else if (location.state?.initialSkillsTab) {
      setSkillsTab(location.state.initialSkillsTab);
    }
  }, [location.state?.tab, location.state?.initialSkillsTab]);

  useEffect(() => {
    if (!location.state?.returnFromLearnOrSkill) return;

    const indices = mergeExpandedIndices(
      location.state?.expandedModuleIndices,
      location.state?.scrollToModuleIndex,
    );
    if (loading || !indices?.length) return;
    persistedExpandedIndicesRef.current = indices;
    setLearningData((prev) => {
      if (!prev?.Topics?.length) return prev;
      const needsRestore = indices.some(
        (i) => prev.Topics[i] && !prev.Topics[i].isExpand,
      );
      if (!needsRestore) return prev;
      const next = applyExpandedModuleIndices(prev, indices);
      syncExpandedIndicesRef(next.Topics);
      return next;
    });
  }, [
    location.state?.returnFromLearnOrSkill,
    location.state?.expandedModuleIndices,
    location.state?.scrollToModuleIndex,
    loading,
  ]);

  useEffect(() => {
    if (loading || !location.state?.returnFromLearnOrSkill) return;

    let scrollToModuleIndex = location.state?.scrollToModuleIndex;
    if (
      (typeof scrollToModuleIndex !== "number" || scrollToModuleIndex < 0) &&
      (location.state?.targetModuleId || location.state?.targetModuleName)
    ) {
      const foundIdx = learningData?.Topics?.findIndex(
        (t) =>
          (location.state?.targetModuleId &&
            (t.module_id === location.state.targetModuleId ||
              t.id === location.state.targetModuleId ||
              t._id === location.state.targetModuleId)) ||
          (location.state?.targetModuleName &&
            t.module_name?.trim().toLowerCase() ===
              location.state.targetModuleName?.trim().toLowerCase())
      );
      if (foundIdx !== undefined && foundIdx >= 0) {
        scrollToModuleIndex = foundIdx;
      }
    }

    setSkillsTab("all-skills");

    const clearStateTimer = setTimeout(() => {
      navigate(location.pathname, { replace: true, state: null });
    }, 1000);

    if (typeof scrollToModuleIndex !== "number" || scrollToModuleIndex < 0) {
      return () => clearTimeout(clearStateTimer);
    }

    const scrollToModule = () => {
      const el = moduleRefs.current[scrollToModuleIndex];
      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    };

    // Single smooth scroll to module after expand content renders
    const moduleTimer = setTimeout(scrollToModule, 350);

    return () => {
      clearTimeout(moduleTimer);
      clearTimeout(clearStateTimer);
    };
  }, [
    loading,
    location.state?.returnFromLearnOrSkill,
    location.state?.scrollToModuleIndex,
    location.state?.targetModuleId,
    location.state?.targetModuleName,
    navigate,
    location.pathname,
    learningData?.Topics,
  ]);

  useEffect(() => {
    if (!learningPaceModID) return;
    if (learningPaceModID) learningPace(learningPaceModID, dateForLP);
    if (learningLevelModID) learningLevel(learningLevelModID);
  }, [learningPaceModID, dateForLP]);

  return (
    <div className={style.container}>
      {loading ? <Loader /> : null}
      {Object.keys(learningData).length === 0 && !loading ? (
        <div className={style.info}>
          <p></p>
        </div>
      ) : (
        <div className={style.learningSection}>
          <div className={style.learningHeadSection}>
            <div className={style.learningHeadText}>
              <p>Modules</p>
              <span>Welcome to the learning part of GrammarLocker</span>
            </div>
            <div className={style.learnImg}>
              <img src={Study} alt="Learn" />
            </div>
          </div>
          <div className={style.learningHeader}>
            <h3>GrammarLocker</h3>
            <p>
              Your GrammarLocker is divided into{" "}
              <span className={style.highlightText}>seven modules, each with between 4 and 12 topics.</span>
              &nbsp;Every grammar topic is explained in a concise, written
              lesson – click Lesson to go through each one.
            </p>
            <p>
              Then, once you have  read through the lesson, head to the Exercises area. Here you’ll apply the principles you have learnt in practical, everyday, real-world English examples. The exercises are organised by bite-sized skills so you know exactly what you’ve grasped and can pinpoint precisely any areas where you need more focus. 
            </p>
            <p>
              There are also Flashcards – quickfire questions if you’re looking for a speedy recap of the basics.
            </p>
            <p>
              At the end of each Topic, you complete the Topic Test. You can retest at any point – and we recommend you do, not just to improve your scores, but to keep practising and make it stick.
            </p>
            <p>
              Don't forget your punctuation - only accurately punctuated answers
              will be marked as correct! (If you need to brush up on the rules,
              head to Module 5 Topic 7 for a refresher!)
            </p>
          </div>

          <div ref={tabSectionRef} className={style.buttonRow}>
            <button className={style.focusZoneButton} onClick={() => navigate("/focus-zone")}>
            <img src={TargetIcon} alt="" />
              Focus Zone
            </button>
            <button className={style.progressButtonNew} onClick={() => navigate("/performance")}>
              Check my progress
            </button>
          </div>

          {skillsTab === "Strength" && (
            <div className={style.backContainer}>
              <button className={style.backButton} onClick={() => setSkillsTab("all-skills")}>
                &larr; Back to Modules
              </button>
            </div>
          )}

          {skillsTab === "all-skills" && (
            <>
              <div className={style.statusAndActionsRow}>
                <div className={style.statusSectionNew}>
                  <div className={style.statusCardNew}>
                    <span className={style.completeIndicator}></span>
                    <p>Topic complete</p>
                  </div>
                  <div className={style.statusCardNew}>
                    <span className={style.inProgressIndicator}></span>
                    <p>Topic in progress</p>
                  </div>
                  <div className={style.statusCardNew}>
                    <span className={style.notStartedIndicator}></span>
                    <p>Topic not started</p>
                  </div>
                </div>

                <div className={style.expandCollapseActions}>
                  <button className={style.subheadWrapperNew} onClick={toggleExpandAll}>
                    <img
                      src={
                        learningData?.Topics?.every((topic) => topic.isExpand)
                          ? collapse
                          : expand
                      }
                      alt="toggle"
                    />
                    <p>
                      {learningData?.Topics?.every((topic) => topic.isExpand)
                        ? "Collapse All"
                        : "Expand All"}
                    </p>
                  </button>
                </div>
              </div>

              <div className={style.moduleSection} ref={moduleSectionRef}>
                <div className={style.moduleSectionBody}>
                  {learningData?.Topics?.length > 0 &&
                    learningData.Topics.map((mod, i) => (
                      <div
                        className={style.moduleCard}
                        key={i}
                        ref={(el) => {
                          if (el) moduleRefs.current[i] = el;
                          else delete moduleRefs.current[i];
                        }}
                      >
                        <div className={style.moduleCardTop}>
                          <div className={style.moduleCardName}>
                            <p>Module {i + 1}</p>
                          </div>
                          <div className={style.moduleCount}>
                            {mod.topics.map((topic, j) => (
                              <div
                                key={j}
                                className={style.moduleCountColor}
                                style={{
                                  background:
                                    topic.status === "complete"
                                      ? "#00DFC7"
                                      : topic.status === "In Progress"
                                        ? "#FFB563"
                                        : "#D9D9D9",
                                }}
                              />
                            ))}
                          </div>
                        </div>

                        <div className={style.moduleCardBottom}>
                          <div className={style.moduleCardBottomLeft}>
                            <p>
                              {mod.module_name.replace(/Module \d+\s*:\s*/, "")}
                            </p>
                          </div>
                          <div className={style.moduleCardBottomRight}>
                            {mod.isExpand ? (
                              <BsChevronUp onClick={() => toggleExpand(i)} />
                            ) : (
                              <BsChevronDown onClick={() => toggleExpand(i)} />
                            )}
                          </div>
                        </div>

                        {mod.isExpand && (
                          <div className={style.topicContainer}>
                            {mod.topics.map((topic, j) => {
                              const isTrial =
                                userDetails?.user_type === "Trail";
                              const isEnabled =
                                (!isTrial ||
                                  (i === 0 && j < enabledTopicForTrialUSer)) &&
                                mod.release_status;

                              return (
                                <div
                                  key={j}
                                  // onClick={() => navigate("/new/learnings/detail", {
                                  //   state: {
                                  //     mainId: mod.topic_id,
                                  //     singleTopic: topic,
                                  //     learning: learningData.learning_id,
                                  //     mapped: learningData.admin_mapped_lessons,
                                  //     topic_no: j + 1,
                                  //     userID: userDetails && userDetails._id?.$oid,
                                  //     orgID: userDetails && userDetails.org_id
                                  //   }
                                  // })}
                                  className={`${style.topicCard} ${
                                    topic.status === "complete"
                                      ? style.complete
                                      : topic.status === "In Progress"
                                        ? style.inProgress
                                        : style.notStarted
                                  } ${!isEnabled || mod.release_status !== true ? style.disabledCard : ""}`}
                                >
                                  <p>
                                    Topic {j + 1}: {topic.value}
                                  </p>
                                  <div className={style.actionBtn}>
                                    <button
                                      className={style.learnBtn}
                                      onClick={() =>
                                        navigate("/new/learnings/detail", {
                                          state: {
                                            mainId: mod.topic_id,
                                            singleTopic: topic,
                                            learning: learningData.learning_id,
                                            mapped:
                                              learningData.admin_mapped_lessons,
                                            topic_no: j + 1,
                                            userID:
                                              userDetails &&
                                              userDetails._id?.$oid,
                                            orgID:
                                              userDetails && userDetails.org_id,
                                            expandedModuleIndices:
                                              getExpandedIndicesForNav(
                                                learningData.Topics,
                                                i,
                                              ),
                                            scrollToModuleIndex: i,
                                          },
                                        })
                                      }
                                    >
                                      <img
                                        src={learnIcon}
                                        className={style.learnImg}
                                        alt=""
                                      />{" "}
                                      Lesson
                                    </button>

                                    <button
                                      className={style.skillBtn}
                                      onClick={async () => {
                                        const fetchedId = await fectchAiId(
                                          topic.id,
                                        );

                                        navigate("/subtopic", {
                                          state: {
                                            aiId: fetchedId,
                                            topicId: topic.id,
                                            topicIndex: j + 1,
                                            topicValue: topic.value,
                                            moduleName: mod.module_name,
                                            moduleIndex: i + 1,
                                            searchTerm: "",
                                            expandedModuleIndices:
                                              getExpandedIndicesForNav(
                                                learningData.Topics,
                                                i,
                                              ),
                                            scrollToModuleIndex: i,
                                          },
                                        });
                                      }}
                                    >
                                      <img
                                        src={skillIcon}
                                        className={style.skillImg}
                                        alt=""
                                      />{" "}
                                      Exercises
                                    </button>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    ))}
                </div>
              </div>
            </>
          )}

          {skillsPanelsActive && (
            <>
              <div
                className={
                  skillsTab === "trouble-spots"
                    ? style.skillsTabPanel
                    : style.skillsTabPanelHidden
                }
              >
                <Trouble />
              </div>
              <div
                className={
                  skillsTab === "Strength"
                    ? style.skillsTabPanel
                    : style.skillsTabPanelHidden
                }
              >
                <Strength />
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default ModulePage;
